module.exports = __webpack_public_path__ + "img/homeProduct3.c0935666.png";